"use strict";
import * as React from "react";
import { useParams } from "react-router-dom";
import QuickSight from "../common/QuickSight";
import { monitoringInfoList } from "../../_constants/PageInfoList";
import { viewId } from "../../_constants/Code";

const LegalDisclosure = (props) => {
  const page = monitoringInfoList.find(page => { return page.key === "10"; });
  return (
    <main className="page-container">
      <section className="page-content">
        <div className="centered-container">
          <QuickSight
            pageId={viewId.legalDisclosure}
            pageInfo={page}
            dashboardList={page.dashboardList}
            listNum={props.params.listNum}
            listNumSub={props.params.listNumSub}
            isKpi={false}
            isBenchmark={true}
          />
        </div>
      </section>
    </main>
  );
};

export default (props) => <LegalDisclosure {...props} params={useParams()} />;
